import React from 'react';
import { Platform, Text, View } from 'react-native';
import colors from './colors';

const renderers = {
  note: (htmlAttribs, children, convertedCSSStyles, passProps) => (
    <Text style={{ marginBottom: 10, }} key={passProps.key}>{children}</Text>
  ),
  tab: (htmlAttribs, children, convertedCSSStyles, passProps) => (
    <Text key={passProps.key}> {children}</Text>
  ),
  line: (htmlAttribs, children, convertedCSSStyles, passProps) => (
    <Text style={{ marginBottom: 10, }} key={passProps.key}>{children}</Text>
  ),
  h2: (htmlAttribs, children, convertedCSSStyles, passProps) => (
    <Text
      style={{
        fontFamily: 'FiraSans-SemiBold',
        fontSize: 20,
        fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
        fontStyle: 'normal',
        lineHeight: 26,
        letterSpacing: -0.1,
        color: colors.primary,
        marginTop: 16,
        marginBottom: 8,
      }}
      key={passProps.key}>
      {children}
    </Text>
  ),
  /* Below breaks iOS/ Android read modals */
  sup: {
    renderer: (htmlAttribs, children, convertedCSSStyles, passProps) => {
      if (Platform.OS === 'android') {
        return (
          <View
            style={{
              marginHorizontal: 3,
              alignItems: 'center',
            }}
            key={passProps.key}>
            <Text>
              {children}
            </Text>
          </View>
        );
      }

      return (
        <Text
          style={{
            flexDirection: 'column',
          }}
          key={passProps.key}>
          <Text
            style={{
              marginHorizontal: 3,
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}>
            {' '}
          </Text>
          <View style={{
            height: 28 * (passProps.renderersProps.fontMultiplier || 1),
            alignItems: 'center',
          }}>
            <Text>
              {children}
            </Text>
          </View>
          <Text>
            {' '}
          </Text>
        </Text>
      )
    },
    wrapper: 'Text'
  },
};

export default renderers;